import React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';

const SFSegmentedTabs = ({ id, tabs, value, handleChange }) => {
    return (
        <Box sx={{ width:'100%', marginBottom:'12px' }}>
            <Tabs
                value={value}
                onChange={(_, newValue) => handleChange(newValue)}
                aria-label={id}
                TabIndicatorProps={{ style: { display: 'none' } }}
                sx={{
                    minHeight: "40px",
                    border:'1px solid #bb0000',
                    background:'#fff',
                }}
            >
                {tabs.map((tab, index) => {
                    return (
                        <Tab
                            key={index}
                            label={tab.label}
                            value={tab.value}
                            sx={{
                                flex: 1,
                                textTransform: "none",
                                minHeight: "40px",
                                // padding: "8px 20px",
                                fontSize: "14px",
                                borderRadius: 0,
                                margin: 0,
                                color: "#bb0000",

                                "&.Mui-selected": {
                                    backgroundColor: "#bb0000",
                                    color: "#fff",
                                },

                                "&:hover": {
                                    backgroundColor:
                                        value === tab.value ? "#bb0000" : "rgba(0,0,0,0.05)",
                                },
                            }}
                        />
                    );
                })}
            </Tabs>
        </Box>
    );
};

export default SFSegmentedTabs;
